import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import ExpandMore from "@mui/icons-material";
import { ConnectBankAccount } from "../ConnectBankAccount";
import { useAccelContext } from "../../contexts/AccelContext/AccelContext";
import { mix } from "polished"; // Import the mix function from polished
import { useAccountContext } from "../../contexts/AccountsContext/AccountsContext";
import { AccelPlaidAccount } from "../../types/AccelPlaidAccount";
import { CompanyPlaidAccounts } from "../../types/CompanyPlaidAccounts";

// Mock data for the accounts



interface AccountCardProps {
  account: CompanyPlaidAccounts;
  notBank?: boolean;
}

const AccountCard: React.FC<AccountCardProps> = ({ account }) => {
  const { theme } = useAccelContext();
  return (
    <Card
      sx={{
        background: `conic-gradient(from 246.83deg at 100%, ${theme?.accent?.hex} 0%, ${theme?.primary?.hex} 50%, ${theme?.accent?.hex} 100%)`,
        height: "100%",
        color: theme?.text?.hex,
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle1">{account.name}</Typography>
          <Typography variant="caption">{account.type}</Typography>
        </Box>
        <Typography variant="body2">
          Subtype: {account.subtype}
        </Typography>
        <Typography variant="body2">Mask: {account.mask}</Typography>
      </CardContent>
    </Card>
  );
};

const AccountsWidget = () => {
  const { theme } = useAccelContext();
  const { accounts } = useAccountContext();
 
  const halfwayColor = mix(
    0.2,
    theme?.secondary?.hex || "#000000",
    theme?.accent?.hex || "#000000"
  );

  return (
    <Box>
      <Accordion
        defaultExpanded
        sx={{ backgroundColor: halfwayColor, color: theme?.text?.hex }}
      >
        <AccordionSummary>
          <Typography>Connected Bank Accounts</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{ backgroundColor: theme?.accent?.hex, color: theme?.text?.hex }}
        >
          <Grid container spacing={2}>
            <ConnectBankAccount></ConnectBankAccount>
            {accounts?.map((account) => (
              <Grid item key={account.account_id} xs={12} sm={6} md={4} lg={3}>
                <AccountCard account={account} />
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default AccountsWidget;
